import { useEffect } from "react";
import { Banner } from "@shopify/polaris";

import { useShopQuery } from "../../hooks/index.js";
import { updateShop } from "../../store/features/shop.js";
import { updateHost } from "../../store/features/host.js";
import {
  SSE_CONNECT,
  SSE_GET_PRODUCTS_BULK_OPERATION_FAILED,
  SSE_GET_PRODUCTS_BULK_OPERATION_FINISH, SSE_PRODUCT_MESSAGE
} from "../../../constants/sseEvents.js";
import {
  sessionRequestFailed,
  sessionRequestSuccess,
  setSessionMessage,
  updateUserUUID
} from "../../store/features/sseSession.js";
import { useAppDispatch, useAppSelector } from "../../hooks/redux.js";
import { closeModal } from "../../store/features/modal.js";
import Loading from "../common/Loading/Loading.js";

export const AppMainProvider = ({ children }) => {
  const dispatch = useAppDispatch();
  const shop = useAppSelector((state) => state.shop.data);
  const host = useAppSelector((state) => state.host.data);
  const userUUID = useAppSelector((state) => state.sseSession.userUUID);

  const { status, refetch } = useShopQuery({
    onSuccess: (data) => {
      dispatch(updateShop(data));
    }
  });

  useEffect(() => {
    const host = new URLSearchParams(window?.location?.search).get("host");
    if (host) {
      dispatch(updateHost(host));
    }
  }, []);

  useEffect(() => {
    if (!userUUID) {
      const eventSource = new EventSource("/api/sse");
      //connect sse session
      eventSource.addEventListener(SSE_CONNECT, ({ data }) => {
        dispatch(updateUserUUID(JSON.parse(data)));
      });

      //GET_PRODUCTS_BULK_OPERATION_FINISH
      // eventSource.addEventListener(SSE_GET_PRODUCTS_BULK_OPERATION_FINISH, ({ data }) => {
      //   refetch()
      //   dispatch(closeModal())
      //   dispatch(sessionRequestSuccess())
      // });

      // //GET_PRODUCTS_BULK_OPERATION_FAILED
      // eventSource.addEventListener(SSE_GET_PRODUCTS_BULK_OPERATION_FAILED, ({ data }) => {
      //   dispatch(sessionRequestFailed(JSON.parse(data)));
      // });

      // //get sse message
      // eventSource.addEventListener(SSE_PRODUCT_MESSAGE, ({ data }) => {
      //   dispatch(setSessionMessage(JSON.parse(data)))
      // });

    }

    return () => {
      if (userUUID) {
        //close sse session
        navigator.sendBeacon("/api/sse-close", userUUID);
        dispatch(updateUserUUID(null));
      }
    };
  }, [userUUID]);

  if (status === "error") {
    return (
      <Banner status={"critical"} title={"Fetch shop data error"}>
        <p>API Server Error</p>
      </Banner>
    );
  }

  useEffect(() => {
    setInterval(() => refetch(), 60000);
  }, []);


  return (
    <>
      <ui-nav-menu>
        <a href="/" rel="home">Home</a>
        <a href="/billing">Billing</a>
        <a href="/documentation">Documentation</a>
        <a href="/gethelp">Get Help</a>
        <a href="/suggestionbox">Suggestion Box</a>
      </ui-nav-menu>
      {shop && host && userUUID ? children : <Loading />}
    </>
  );
};

